import request from '@/utils/request'

let ExportApi = {

  /*进出口列表*/
  list(data) {
    return request._post('/shop/plus.export.Index/index', data);
},
/*添加进出口*/
add(data) {
    return request._post('/shop/plus.export.Index/add', data);
},
/*修改进出口*/
edit(data) {
    return request._post('/shop/plus.export.Index/edit', data);
},
/*删除进出口*/
del(data) {
    return request._post('/shop/plus.export.Index/del', data);
},
/*进出口详情*/
detail(data) {
  return request._post('/shop/plus.export.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.export.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.export.Setting/getSetting', data, errorback);
    },
}
export default ExportApi;



// WEBPACK FOOTER //
// ./src/api/export.js